import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCreativesData, postShowcase, postShowcaseShare, putShowcase } from "../../helpers/backend_helper";
import { setBannerFilter, setSelectedShowcaseVersion, setSelectedSizes, setSendLinkViaEmail, setShowcaseId, setShowcaseLink, setShowcasePwd, setShowcaseSizes, setVersionIds } from "./reducer";
import api from '../../config';
import { toast } from "react-toastify";
import { setShowcaseModalLoader } from "../modals/reducer";
const showcaseUrl = api[api.status].showcaseUrl;

export const resetShowcase = () => async (dispatch, getState) => {
  try {
    dispatch(setSelectedShowcaseVersion(null));
    dispatch(setBannerFilter(null));
    dispatch(setShowcaseSizes(null));
    dispatch(setSelectedSizes([]));
    dispatch(setShowcasePwd(null));
    dispatch(setShowcaseLink(null));
    dispatch(setShowcaseId(null));
    dispatch(setVersionIds(null));
    dispatch(setSendLinkViaEmail({ addresses: '', message: '' }));
  } catch (error) {
    // console.log(error);
  }
}

export const getFilteredSizes = createAsyncThunk('showcase/getFilteredSizes', async (params, { dispatch, getState }) => {
  try {
    const { selectedShowcaseVersion, bannerFilter } = getState().Showcase;
    const { versions } = getState().Campaign;
    const filteredSizes = [];

    if (selectedShowcaseVersion.value === 'all') {
      let i = 0;
      do {
        const versionRes = await getCreativesData({ versionId: versions[i]._id });
        if (versionRes.status === 'ok') {
          filteredSizes.push(...versionRes.data);
        }
        i++;
      } while (i < versions.length);
    } else {
      if (selectedShowcaseVersion) {
        const versionRes = await getCreativesData({ versionId: selectedShowcaseVersion.value });
        if (versionRes.status === 'ok') {
          filteredSizes.push(...versionRes.data);
        }
      }
    }
    return filteredSizes;
  } catch (error) {
    // console.log(error);
  }
});

export const filterSizesByApprovement = (version) => async (dispatch, getState) => {
  try {
    const { bannerFilter, selectedSizes } = getState().Showcase;
    const creativeIds = [];
    const sizes = [];
    let i = 0;
    do {
      if (version._id === selectedSizes[i].versionId) {
        if (bannerFilter.value === 'all') {
          creativeIds.push(selectedSizes[i]._id);
          sizes.push(selectedSizes[i].size);
        } else if (bannerFilter.value === 'approved') {
          if (selectedSizes[i].approvement === true) {
            creativeIds.push(selectedSizes[i]._id);
            sizes.push(selectedSizes[i].size);
          }
        } else if (bannerFilter.value === 'non-approved') {
          if (selectedSizes[i].approvement === false) {
            creativeIds.push(selectedSizes[i]._id);
            sizes.push(selectedSizes[i].size);
          }
        }
      }
      i++;
    } while (i < selectedSizes.length);
    return { creativeIds: creativeIds, sizes: sizes };
  } catch (error) {
    // console.log(error);
  }
}

export const createShowcase = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { currentCampaign, versions } = getState().Campaign;
    const { selectedShowcaseVersion, password, showcaseId, selectedSizes } = getState().Showcase;
    const postVersions = [];
    dispatch(setShowcaseModalLoader(true));
    if (selectedSizes.length > 0) {
      if (showcaseId === null) {
        if (selectedShowcaseVersion.value === 'all') {
          let i = 0;
          do {
            const filteredSizes = await dispatch(filterSizesByApprovement(versions[i]));
            postVersions.push({ ...versions[i], creativeIds: filteredSizes.creativeIds, sizes: filteredSizes.sizes });
            i++;
          } while (i < versions.length);
        } else if (selectedShowcaseVersion) {
          const foundVersion = versions.find(item => item._id === selectedShowcaseVersion.value);
          const filteredSizes = await dispatch(filterSizesByApprovement(foundVersion));
          postVersions.push({ ...foundVersion, creativeIds: filteredSizes.creativeIds, sizes: filteredSizes.sizes });
        }
        // console.log(postVersions);
        const res = await postShowcase({
          campaignId: currentCampaign._id,
          versions: postVersions,
          password: password
        });
        // console.log(res);
        if (res.status === 'ok') {
          // console.log(postVersions);
          const query = postVersions.map(item => {
            if (item.hasOwnProperty('feeds') && Array.isArray(item?.feeds)) {
              return item._id + ':' + item.feeds[0]
            } else {
              return item._id;
            }
          });
          dispatch(setShowcaseId(res.data.insertedId));
          dispatch(setShowcaseLink(`${showcaseUrl}/${res.data.insertedId}?versionIds=${query.join(",")}`));
        }
      } else {
        await dispatch(updateShowcase());
      } 
      dispatch(setShowcaseModalLoader(false));
    } else {
      toast.error('Please select size', {autoClose: 3000});
      dispatch(setShowcaseModalLoader(false));
    }
  } catch (error) {
    dispatch(setShowcaseModalLoader(false));
    console.log('error', error);
    toast.error(language[error?.code], {autoClose: 3000});
    // console.log(error);
  }
}

export const sendLinkViaEmail = () => async (dispatch, getState) => {
  try {
    const { sendLinkViaEmail, showcaseId } = getState().Showcase;
    if (showcaseId) {
      const res = await postShowcaseShare({ id: showcaseId, message: sendLinkViaEmail.message, addresses: sendLinkViaEmail.addresses });
      // console.log(res);
    }
  } catch (error) {
    // console.log(error);
  }
}

export const handleSetPassword = (pwd) => async (dispatch, getState) => {
  try {
    const { showcaseId } = getState().Showcase;
    dispatch(setShowcasePwd(pwd));
    if (showcaseId) {
      // Update Showcase 
      dispatch(updateShowcase());
    }
  } catch (error) {
    // toast.error('', {autoClose: 3000})
    // console.log(error);
  }
}

export const updateShowcase = () => async (dispatch, getState) => {
  const {language} = getState().MenuData;
  try {
    const { showcaseId, password } = getState().Showcase;
    const res = await putShowcase({ id: showcaseId, password: password });
    if (res.status === 'ok') {
      toast.success(language[res?.code], {autoClose: 3000});
    } else {
      throw res;
    }
    // console.log(res);
  } catch (error) {
    toast.error(language[error?.code], {autoClose: 3000});
    // console.log(error);
  }
}